import { createSelector } from '@reduxjs/toolkit';

import { connectionSelector } from 'src/selectors/connection';
import { stardogVersionByConnectionIdSelector } from 'src/selectors/stardogVersionByConnectionId';

export const currentStardogVersionSelector = createSelector(
  connectionSelector,
  stardogVersionByConnectionIdSelector,
  (connection, stardogVersionByConnectionId) =>
    (connection && stardogVersionByConnectionId[connection.id]) || '0.0.0'
);
